import { LogoSizes } from "@/types/enums"
import Image from "next/image"
import clsx from "clsx"
import { getDirecutsImageUrl } from "@/app/utils/getDirectusImageUrl";
import store from "@/store/store";
import { observer } from "mobx-react-lite";

type LogoProps = {
    size?: LogoSizes;
    variant?: "light" | "dark";
    // Fills the height of its parent (keeps the aspect ratio), so a flex parent can shrink the logo.
    fitHeight?: boolean;
}

const Logo = observer(function Logo({ size = LogoSizes.MEDIUM, variant = "light", fitHeight = false }: LogoProps) {
    const imageClassName = fitHeight ? "w-auto max-w-full h-full object-contain" : "max-w-full h-auto";

    const noShitWidth = size === LogoSizes.SMALL && 176 || size === LogoSizes.MEDIUM && 240 || size === LogoSizes.LARGE && 335 || 122
    const noShitHeight = size === LogoSizes.SMALL && 117 || size === LogoSizes.MEDIUM && 160 || size === LogoSizes.LARGE && 221 || 79
    const tr = store.globalData?.translations?.[0];
    const noShitSrc = tr?.noShit_logo ? getDirecutsImageUrl(tr.noShit_logo.toString()) : "/images/NoShitLogoWithSubline.png";
    const noShitSrcDark = tr?.noShit_logo_dark ? getDirecutsImageUrl(tr.noShit_logo_dark.toString()) : "/images/NoShitLogoDark.png";

    const logoOverride = store.specialMonthData?.logo_override;
    const logoSrc =
        typeof logoOverride === "string" && logoOverride.trim().length > 0
            ? getDirecutsImageUrl(logoOverride)
            : noShitSrc;

    const logoSrcDark =
        typeof logoOverride === "string" && logoOverride.trim().length > 0
            ? getDirecutsImageUrl(logoOverride)
            : noShitSrcDark;

    return (
        <div className={clsx("flex flex-col items-center gap-2 w-full", fitHeight ? "h-full" : "h-auto")}>
            {variant === "light" ?
                <Image
                    src={logoSrc}
                    alt="Logo"
                    width={noShitWidth}
                    height={noShitHeight}
                    className={imageClassName}
                />
                :
                <Image
                    src={logoSrcDark}
                    alt="Logo"
                    width={noShitWidth}
                    height={noShitHeight}
                    className={imageClassName}
                />
            }
        </div>
    )
})

export default Logo;
